import * as z from 'zod/mini';

export const EventType = z.literal(
	Object.values(window.splashmakerEventsConfig.eventTypes),
);
